import { NeutralPalette } from './types';

const neutralPalette: NeutralPalette = {
  grey50: '#FAFAFA',
  grey100: '#F5F5F5',
  grey200: '#EFEFEF',
  grey300: '#E1E1E1',
  grey400: '#BEBEBE',
  grey500: '#9F9F9F',
  grey600: '#767676',
  grey700: '#626262',
  grey800: '#434343',
  grey900: '#212121',
  light50: 'rgba(0,0,0,0.02)',
  light100: 'rgba(0,0,0,0.04)',
  light200: 'rgba(0,0,0,0.06)',
  light300: 'rgba(0,0,0,0.12)',
  light400: 'rgba(0,0,0,0.26)',
  light500: 'rgba(0,0,0,0.38)',
  light600: 'rgba(0,0,0,0.54)',
  light700: 'rgba(0,0,0,0.62)',
  light800: 'rgba(0,0,0,0.74)',
  light900: 'rgba(0,0,0,0.88)',
  dark50: 'rgba(255,255,255,0.04)',
  dark100: 'rgba(255,255,255,0.06)',
  dark200: 'rgba(255,255,255,0.12)',
  dark300: 'rgba(255,255,255,0.26)',
  dark400: 'rgba(255,255,255,0.38)',
  dark500: 'rgba(255,255,255,0.46)',
  dark600: 'rgba(255,255,255,0.62)',
  dark700: 'rgba(255,255,255,0.74)',
  dark800: 'rgba(255,255,255,0.88)',
  dark900: 'rgba(255,255,255,0.94)',
  white: '#FFFFFF',
  black: '#000000',
};

export default neutralPalette;
